import "./LocalizedFileInput.scss";

const LocalizedFileInput = ({
  id,
  className = "",
  nativeClassName = "mediaFile",
  accept,
  onChange,
  onInvalid,
  onInput,
  chooseFileText,
  noFileChosenText,
  fileName,
  inputRef,
  required = false,
  multiple = false,
  title,
}) => {
  const displayName = fileName || noFileChosenText;

  return (
    <div className={`localized-file-input ${className}`.trim()} title={title}>
      <input
        type="file"
        id={id}
        className={`localized-file-input__native ${nativeClassName}`.trim()}
        onChange={(e) => {
          e.target.setCustomValidity("");
          if (onChange) onChange(e);
        }}
        onInvalid={onInvalid}
        onInput={(e) => {
          e.target.setCustomValidity("");
          if (onInput) onInput(e);
        }}
        accept={accept}
        ref={inputRef}
        required={required}
        multiple={multiple}
      />
      <label htmlFor={id} className="localized-file-input__button">
        {chooseFileText}
      </label>
      <span className="localized-file-input__filename" title={displayName}>
        {displayName}
      </span>
    </div>
  );
};

export default LocalizedFileInput;
